import { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

function useUrlSearchParamsState(key, defaultValue = '') {
  const location = useLocation();
  const navigate = useNavigate();
  const [paramValue, setParamValue] = useState(() => {
    const params = new URLSearchParams(location.search);
    return params.get(key) || defaultValue;
  });

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const value = params.get(key);
    if (value !== paramValue) {
      setParamValue(value || defaultValue);
    }
  }, [location.search, key, paramValue, defaultValue]);

  const updateUrlParam = (newValue) => {
    const params = new URLSearchParams(location.search);
    if (newValue) {
      params.set(key, newValue);
    } else {
      params.delete(key);
    }
    navigate({ search: params.toString() }, { replace: true });
    setParamValue(newValue);
  };

  return [paramValue, updateUrlParam];
}

export default useUrlSearchParamsState;
